import { TMapBounds } from '../../../shared/Map'
import { IEquipment } from '../../Equipment/equipment.types.ts'

class MapEquipmentFilter {
  private readonly sortedByLat: IEquipment[]

  constructor(equipment: IEquipment[]) {
    this.sortedByLat = [...equipment.filter((e) => Boolean(e.location))]
    this.sortedByLat.sort((a, b) => +a.location.latitude - +b.location.latitude)
  }

  private static latGetter(e: IEquipment) {
    return +e.location.latitude
  }

  private static binarySearch<T, U extends Primitive>(array: T[], searchingElement: U, getter: (el: T) => U): number {
    let left = 0
    let right = array.length - 1

    while (left < right) {
      const mid = left + Math.floor((right - left) / 2)
      const el = getter(array[mid])

      if (el === searchingElement) {
        return mid
      } else if (el > searchingElement) {
        right = mid - 1
      } else {
        left = mid + 1
      }
    }

    return left
  }

  public getFittedIntoBounds(bounds: TMapBounds) {
    if (!this.sortedByLat.length) return []

    let leftLatBoundIndex = MapEquipmentFilter.binarySearch(
      this.sortedByLat,
      bounds.rectangleBottomRightPoint.latitude,
      MapEquipmentFilter.latGetter
    )
    let rightLatBoundIndex = MapEquipmentFilter.binarySearch(
      this.sortedByLat,
      bounds.rectangleTopLeftPoint.latitude,
      MapEquipmentFilter.latGetter
    )

    if (bounds.rectangleTopLeftPoint.latitude < +this.sortedByLat[leftLatBoundIndex].location.latitude)
      leftLatBoundIndex++
    if (bounds.rectangleBottomRightPoint.latitude > +this.sortedByLat[rightLatBoundIndex].location.latitude)
      rightLatBoundIndex--

    const resultingArray = []
    for (let i = leftLatBoundIndex; i < rightLatBoundIndex + 1; i++) {
      if (
        bounds.rectangleTopLeftPoint.longitude <= +this.sortedByLat[i].location.longitude &&
        +this.sortedByLat[i].location.longitude <= bounds.rectangleBottomRightPoint.longitude
      ) {
        resultingArray.push(this.sortedByLat[i])
      }
    }

    return resultingArray
  }
}

type Primitive = number | boolean | string

export default MapEquipmentFilter
